import { Link } from 'react-router-dom';
import { useLang } from '@/i18n/LanguageContext';
import LanguageToggle from './LanguageToggle';

const HOVER_BLUE = '#0057FF';

const linkStyle: React.CSSProperties = {
  fontFamily: "'IBM Plex Mono', monospace",
  fontSize: 'var(--type-caption)',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: 'var(--lp-muted)',
  textDecoration: 'none',
  transition: 'color 0.2s ease',
};

export default function PublicFooter() {
  const { t, lp } = useLang();

  const links = [
    { to: lp('/sobre'), label: t('footer.sobre') },
    { to: lp('/') + '#planos', label: t('footer.planos'), isAnchor: true },
    { to: lp('/termos'), label: t('footer.termos') },
    { to: lp('/privacidade'), label: t('footer.privacidade') },
    { to: lp('/contato'), label: t('footer.contato') },
  ];

  return (
    <footer
      className="public-footer"
      style={{
        borderTop: '0.5px solid var(--lp-border)',
        padding: '2rem 2.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: "'IBM Plex Mono', monospace",
        gap: '1.5rem',
        flexWrap: 'wrap',
      }}
    >
      <Link
        to={lp('/')}
        style={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 'var(--type-ui)',
          fontWeight: 400,
          letterSpacing: '0.22em',
          textTransform: 'uppercase',
          color: 'var(--lp-ink)',
          textDecoration: 'none',
          transition: 'color 0.2s ease',
        }}
        onMouseEnter={e => (e.currentTarget.style.color = HOVER_BLUE)}
        onMouseLeave={e => (e.currentTarget.style.color = 'var(--lp-ink)')}
      >
        criaaa
      </Link>

      <nav className="public-footer-links" style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
        {links.map(l =>
          l.isAnchor ? (
            <a key={l.label} href={l.to} style={linkStyle}
              onMouseEnter={e => (e.currentTarget.style.color = HOVER_BLUE)}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--lp-muted)')}
            >
              {l.label}
            </a>
          ) : (
            <Link key={l.label} to={l.to} style={linkStyle}
              onMouseEnter={e => (e.currentTarget.style.color = HOVER_BLUE)}
              onMouseLeave={e => (e.currentTarget.style.color = 'var(--lp-muted)')}
            >
              {l.label}
            </Link>
          )
        )}
        <LanguageToggle variant="footer" />
      </nav>

      <span style={{ fontSize: 'var(--type-caption)', textTransform: 'uppercase', color: 'var(--lp-muted)', letterSpacing: '0.1em' }}>
        © {new Date().getFullYear()} criaaa
      </span>
    </footer>
  );
}
